import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import IProduitType from '../../models/IProduitType';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionProduitTypeProps {
  isModeSelection?: boolean;
}

class ProduitType extends IBaseModel implements IProduitType {
  idProduitType: Guid = Guid.empty;
  actif: boolean = false;
}

export default function GestionProduitType({ isModeSelection }: IGestionProduitTypeProps) {
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="ProduitType" model={ProduitType} />
  );
}